import { alpha, AppBar, Box, Card, CardHeader, Divider, Grid, IconButton, Paper, SxProps, Theme, Toolbar, Typography, useTheme } from "@mui/material";
import SearchIcon from '@mui/icons-material/SearchOutlined'
import NotificationsIcon from '@mui/icons-material/NotificationsOffOutlined'
import AccountCircleIcon from '@mui/icons-material/AccountCircleOutlined'
import React, { useEffect, useState } from "react";
import WSBackButton from "../../Components/BackButton/BackButton";
import { getComponentProps, unRegisterComponent, updateOrRegisterComponent } from "../../StateManagement/RegisterComponent";
import { WSHeaders } from "../../commonFunctions/HeaderConfig/HeaderConfig";

interface IHeaderProps {
    title: string;
    type?: 'simple' | 'card' | 'new';
    children?: React.ReactNode;
    isBackButton?: boolean;
    url?: string;
    id?: WSHeaders | any;
    isDivider?: boolean
    headerSx?: SxProps<Theme>;
}

export const Header: React.FC<IHeaderProps> = React.memo((props) => {
    const theme = useTheme();
    const [newUrl, setUrl] = useState<string | undefined>(props?.url);
    const [hasBackButton, setBackButton] = useState<boolean | undefined>(props?.isBackButton);

    // Register the component with initial props
    useEffect(() => {
        updateOrRegisterComponent(props?.id, props);
    }, []);
    useEffect(() => () => {
        unRegisterComponent(props?.id);
    }, []);
    // Handle updates from other components
    useEffect(() => {
        const propsed = getComponentProps(props?.id); // Retrieve the updated props
        if (propsed) {
            setUrl(propsed.url);
            setBackButton(propsed.isBackButton);
        }
    }, [props?.id]);

    return (
        <>
            {props?.type === 'card' && (
                <Paper style={{ backgroundColor: '#F8F8FF' }}>
                    <Card style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '8px',
                        padding: '5px',
                        width: '100%',
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                        border: '1px solid #ffffff'
                    }}>
                        <CardHeader
                            title={
                                <Typography id={props?.id} variant="h6" style={{
                                    fontWeight: 'bold',
                                    color: '#333',
                                    fontSize: '1.25rem'
                                }}>
                                    {props?.title}
                                </Typography>
                            }
                            style={{ padding: '16px' }}
                        />
                    </Card>
                    {props?.children}
                </Paper>
            )}
            {props?.type === 'simple' && (
                <Grid item container spacing={2} sx={{ backgroundColor: '#e8edf2', ...props?.headerSx }} style={{ marginTop: 7 }} >
                    <Grid item sm={12} className="header-text" >
                        <Typography className="header-text" sx={{ marginBottom: 2 }}>
                            {hasBackButton && <WSBackButton id="btnScheduleBack" url={newUrl} />}
                            {props?.title}
                        </Typography>
                    </Grid>
                </Grid>

            )}
            {/* {props?.type === 'new' && <AppBar
                position="static"
                sx={{
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${alpha(theme.palette.primary.dark, 0.8)} 100%)`,
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                    borderRadius:  '12px',
                    marginTop: 2,
                    mx: 2,
                    ...props?.headerSx
                }}
            >
                <Toolbar>
                    
                    <Box display="flex" alignItems="center" flexGrow={1}>
                        {hasBackButton && <WSBackButton id="btnScheduleBack" url={newUrl} />}

                        <Typography
                            variant="h6"
                            component="div"
                            sx={{
                                flexGrow: 1,
                                fontWeight: 600,
                                background: 'linear-gradient(45deg, #fff 30%, #e0e0e0 90%)',
                                backgroundClip: 'text',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                textShadow: '0px 2px 4px rgba(0,0,0,0.2)'
                            }}
                        >
                            {props?.title}
                        </Typography>
                    </Box>

                    
                    <Box display="flex" alignItems="center">
                        <IconButton
                            size="large"
                            sx={{
                                color: 'white',
                                mr: 1,
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                                }
                            }}
                        >
                            <SearchIcon />
                        </IconButton>

                        <IconButton
                            size="large"
                            sx={{
                                color: 'white',
                                mr: 1,
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                                }
                            }}
                        >
                            <NotificationsIcon />
                        </IconButton>

                        <IconButton
                            size="large"
                            sx={{
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                                }
                            }}
                        >
                            <AccountCircleIcon />
                        </IconButton>
                    </Box>
                </Toolbar>

                
                <Box
                    sx={{
                        height: '4px',
                        background: 'linear-gradient(90deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.2) 100%)',
                        borderBottomLeftRadius: '12px',
                        borderBottomRightRadius: '12px'
                    }}
                />
            </AppBar>} */}
            
            {!props?.isDivider && <br />}
            {props?.isDivider && <Grid item sm={12} xs={12} style={{ marginTop: 10 }}>
                <Divider />
                <br />
            </Grid>}
        </>
    );
});
